import React, { use, useEffect, useMemo, useState } from 'react';
import { Button } from 'reactstrap';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import renderField from '../../../../shared/components/custom/Field';
// import RenderField from '../../../../shared/components/custom/Field';
// import t, { partial } from '../../../util/translation/translation';
import useConfig from '../../../../util/useConfig';
import Api from '../../../../util/api';
import renderSearchSelectField from '../../../../shared/components/custom/SearchSelect';
import validatePersonParticipants from './validatePersonParticipants';
import renderSelectField from '../../../../shared/components/form/Select';
import t, { partial } from '../../../../util/translation/translation';
import { toast } from 'react-toastify';

const PersonCardForm = ({
  formValues,
  change,
  ticket,
  handleSubmit,
  onClose,
  setTicketGroups,
}) => {
  const config = useConfig();
  const p = partial('EventParticipantsPage');
  const s = partial('shared');
  const [foundUsers, setFoundUsers] = useState([]);

  const userOptions = useMemo(
    () =>
      foundUsers.map((user) => ({
        label: `${user?.firstname} ${user?.lastname} (${user?.phoneNumber})`,
        value: user.userCloudId,
      })),
    [foundUsers]
  );

  const fetchUsers = async (searchStr) => {
    if (searchStr) {
      const { users } = await Api.users.getTeamUsers(
        1,
        10,
        { phoneNumber: 'asc' },
        searchStr,
        config
      );
      setFoundUsers(users);
      change('firstName', null);
      change('lastName', null);
      change('guestAmount', null);
      change('selectedUser', null);
    }
  };
  const handlePickuser = async ({ value }) => {
    const foundUser = foundUsers.find((item) => item.userCloudId === value);
    const { userCloudId, firstname, lastname, phoneNumber, email } = foundUser;
    setFoundUsers([]);
    change('selectedUser', {
      userId: userCloudId,
      firstName: firstname,
      lastName: lastname,
      phone: phoneNumber,
      email: email,
    });
    change('userPhone', phoneNumber);
    change('firstName', firstname);
    change('lastName', lastname);
    change('selectedCompany', null);
    change('guestAmount', null);
  };

  const onSubmitTicketShare = async (values) => {
    try {
      const payload = {
        toUid: values.selectedUser.userId,
        ticketIds: [ticket.id],
        toPhoneNumber: values.selectedUser.phone,
      };

      await Api.tickets.shareTickets(payload);
      toast.success('ticket shared with: ', values.selectedUser.firstName);
      onClose();
      const response = await Api.tickets.myFutureTickets();
      setTicketGroups(response.data);
    } catch (e) {
      toast.error('ticket sharing failed');
    }
  };

  return (
    <form className="form" onSubmit={handleSubmit(onSubmitTicketShare)}>
      <div className="form__form-group mx-2">
        <span className="form-header">{s('user')}</span>
        <div className="marginTop-5" />
        <Field
          name="owner"
          component={renderSearchSelectField}
          placeholder={t('UsersTab.searchForUser')}
          options={userOptions.filter((item) => !!item.value)}
          search={(search) => fetchUsers(search)}
          onChange={handlePickuser}
        />
      </div>
      <div className="form__form-group mx-2">
        <span className="form-header">{s('firstname')}</span>
        <Field
          name="firstName"
          placeholder={s('firstname')}
          disabled
          component={renderField}
        />
      </div>
      <div className="form__form-group mx-2">
        <span className="form-header">{s('lastname')}</span>
        <Field
          name="lastName"
          placeholder={s('lastname')}
          disabled
          component={renderField}
        />
      </div>
      <div className="form__form-group mx-2">
        <span className="form-header">{s('phonenumber')}</span>
        <Field
          name="userPhone"
          placeholder={s('phonenumber')}
          disabled
          component={renderField}
        />
      </div>
      <Button color="primary" type="submit">
        share ticket
      </Button>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'PersonCardForm',
  validate: validatePersonParticipants,
});

const mapStateToProps = (state) => ({
  formValues: getFormValues('PersonCardForm')(state),
});

export default connect(mapStateToProps)(reduxF(PersonCardForm));
